import AboutOurCompany from './AboutOurCompany'

export default AboutOurCompany
